module.exports = __webpack_public_path__ + "assets/placeholder-kyc-reverse.svg";